export default __webpack_public_path__ + "static/cafe_36074-44652c6ffd26ed990ae79e4b18071db2.png";